<template>
  <v-footer class="background-white" padless>
    <v-sheet class="mx-auto my-2"> </v-sheet>
  </v-footer>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import ExternalLink from '@/components/ExternalLink.vue';

@Component({ components: { ExternalLink } })
export default class FooterBar extends Vue {}
</script>

<style scoped>
.background-white {
  background-color: #fff !important;
}
</style>
